import { Format } from 'admin-columns-js/helper/strings';
import EventEmitter from './event-emitter';
var i18n = {
    FINISHED: ACP_Editing.i18n.bulk_edit.feedback.finished,
    UPDATING: ACP_Editing.i18n.bulk_edit.feedback.updating,
    PROCESSED: Format(ACP_Editing.i18n.bulk_edit.feedback.processed, '<span data-processed>0</span>', '<span data-total-items></span>'),
    FAIL: ACP_Editing.i18n.bulk_edit.feedback.failure,
    DONE: ACP_Editing.i18n.done,
    DONE_DESELECT: ACP_Editing.i18n.bulk_edit.selecting.done_deselect,
    CANCEL: ACP_Editing.i18n.cancel,
    ERROR: Format(ACP_Editing.i18n.bulk_edit.feedback.error, '<span data-errors>0</span>'),
};
var ProcessTemplate = "\n\t\t<div class=\"acp-be-progress\">\n\t\t\t<div class=\"acp-be-progress__timer\" data-timer></div>\n\t\t\t<div class=\"acp-be-progress__process\">" + i18n.PROCESSED + " (<span data-percentage></span>)</div>\n\t\t</div>\n\n\t\t<div class=\"acp-be-statusbar\">\n\t\t\t<div class=\"acp-be-statusbar__progress\" data-status-percentage></div>\n\t\t</div>\n\n\t\t<div class=\"errors\" style=\"display: none;\">\n\t\t\t<div class=\"errors__info\">" + i18n.ERROR + "</div>\n\t\t\t<div class=\"errors__lines\"></div>\n\t\t</div>\n\n\t\t<button data-close class=\"button\">Cancel</button>\n";
var Processor = /** @class */ (function () {
    function Processor(column, value, items, processAll) {
        if (processAll === void 0) { processAll = false; }
        this.Events = new EventEmitter();
        this.column = column;
        this.value = value;
        this._items = items;
        this._total = Array.isArray(items) ? items.length : items;
        this._processed = 0;
        this._perPage = ACP_Editing.bulk_edit.updated_rows_per_iteration;
        this._processAll = processAll;
        this._isCanceled = false;
        this._isFinished = false;
        this.errors = [];
        this.timer = {
            seconds: 0,
            minutes: 0,
        };
        this.prepareElement();
        this.startTimer();
        this.prepareJob();
        this.attachCancelEvent();
        this.updateTotal();
        this.updatePercentage(0);
    }
    Processor.prototype.getElement = function () {
        return this.element;
    };
    Processor.prototype.prepareJob = function (page) {
        var _this = this;
        if (page === void 0) { page = 1; }
        if (!this._processAll) {
            this.runJob();
            return;
        }
        if (page === 1) {
            this._items = [];
        }
        jQuery.ajax({
            url: window.location.href,
            method: 'get',
            data: {
                ac_action: 'get_editable_rows',
                ac_page: page,
                _ajax_nonce: AC.ajax_nonce
            }
        }).done(function (response) {
            if (!response.hasOwnProperty('success') || !response.success) {
                return;
            }
            if (!response.data.hasOwnProperty('editable_rows')) {
                return;
            }
            _this._items = [].concat(_this._items, response.data.editable_rows);
            _this._total = _this._items.length;
            if (response.data.rows_per_iteration === response.data.editable_rows.length) {
                _this.updateTotal();
                _this.prepareJob(page + 1);
                return;
            }
            _this.updateTotal();
            _this.runJob();
        });
    };
    Processor.prototype.runJob = function () {
        var _this = this;
        if (this._isCanceled) {
            return;
        }
        var self = this;
        var items = self._items;
        var item_set = items.splice(0, self._perPage);
        if (item_set.length === 0) {
            self.onComplete();
            return;
        }
        this.startUpdateThread(item_set).then(function (response) {
            if (response.success) {
                var num = response.data.total;
                self._processed += num;
                _this.updateProcessed(self._processed);
                if (num > 0 && !self._isCanceled) {
                    self.runJob();
                }
                else {
                    self.onComplete();
                }
            }
            else {
                // Todo
                //this.onFailure();
            }
        });
    };
    Processor.prototype.startUpdateThread = function (ids) {
        return jQuery.ajax({
            url: ajaxurl,
            data: {
                action: 'acp_editing_bulk_request',
                method: 'save',
                list_screen: AC.list_screen,
                layout: AC.layout,
                column: this.column.name,
                ids: ids,
                value: this.value,
                _ajax_nonce: AC.ajax_nonce
            },
            method: 'POST',
            dataType: 'json'
        });
    };
    Processor.prototype.prepareElement = function () {
        var element = document.createElement('div');
        element.classList.add('acp-be-processing');
        element.innerHTML = ProcessTemplate;
        this.element = element;
    };
    Processor.prototype.attachCancelEvent = function () {
        var _this = this;
        var button = this.element.querySelector('[data-close]');
        if (!button) {
            return;
        }
        button.addEventListener('click', function () {
            if (_this._isFinished) {
                button.remove();
                _this.Events.emit('close', {});
            }
            else {
                _this._isCanceled = true;
                _this.onComplete();
            }
        });
    };
    Processor.prototype.processResponse = function (response) {
        this.updateProcessed(response.num_rows_processed);
    };
    Processor.prototype.updateTotal = function () {
        this.element.querySelector('[data-total-items]').innerHTML = this._total;
    };
    Processor.prototype.updateProcessed = function (number) {
        this.element.querySelector('[data-processed]').innerHTML = number;
        var percentage = Math.round((number / this._total) * 100);
        this.updatePercentage(percentage);
    };
    Processor.prototype.updatePercentage = function (percentage) {
        this.element.querySelector('[data-percentage]').innerHTML = percentage + "%";
        this.element.querySelector('[data-status-percentage]').style.width = percentage + "%";
    };
    Processor.prototype.onComplete = function () {
        if (!this._isCanceled) {
            this.element.querySelector('.acp-be-progress__process').innerHTML = Format(i18n.FINISHED, this._total) + ' (100%) <span class="dashicons dashicons-yes"></span>';
        }
        this.element.querySelector('[data-close]').innerHTML = i18n.DONE;
        this.element.querySelector('[data-close]').classList.add('button-primary');
        this.element.querySelector('[data-status-percentage]').classList.add('-finished');
        this._isFinished = true;
        this.stopTimer();
        this.canDismiss = false;
        this.addDeselectDoneButton();
        this.Events.emit('finished');
    };
    Processor.prototype.addDeselectDoneButton = function () {
        var _this = this;
        var button = new DoneButton();
        button.el.addEventListener('click', function (e) {
            e.preventDefault();
            AdminColumns.Table.el.querySelectorAll('.check-column input[type=checkbox]:checked').forEach(function (cb) {
                cb.checked = false;
                cb.dispatchEvent(new Event('change'));
            });
            _this.Events.emit('close');
        });
        this.element.append(button.el);
    };
    Processor.prototype.startTimer = function () {
        var _this = this;
        this.addSecond();
        this.timerInterval = setInterval(function () { _this.addSecond(); }, 1000);
    };
    Processor.prototype.stopTimer = function () {
        clearInterval(this.timerInterval);
    };
    Processor.prototype.addSecond = function () {
        var element = this.element.querySelector('[data-timer]');
        this.timer.seconds++;
        if (this.timer.seconds >= 60) {
            this.timer.seconds = 0;
            this.timer.minutes++;
        }
        element.textContent = (this.timer.minutes ? (this.timer.minutes > 9 ? this.timer.minutes : "0" + this.timer.minutes) : "00") + ":" + (this.timer.seconds > 9 ? this.timer.seconds : "0" + this.timer.seconds);
    };
    return Processor;
}());
export default Processor;
var DoneButton = /** @class */ (function () {
    function DoneButton() {
        this.createElement();
    }
    DoneButton.prototype.createElement = function () {
        var button = document.createElement('button');
        button.classList.add('button', 'done-deselect');
        button.innerText = i18n.DONE_DESELECT;
        button.dataset.close = true;
        this.el = button;
    };
    return DoneButton;
}());
